import { Component, OnInit } from '@angular/core';
import { PreferencesResponse } from '@app-core/models/core.model';
import { DataService } from '@app-core/services/data/data.service';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
})
export class NotificationBannerComponent implements OnInit {
  public showBanner: boolean;
  public showEnabledBanner: boolean;
  public daysRemaining?: number;
  public formattedDate?: string;
  public showDisabledBanner: boolean;
  public showExpireBanner: boolean;
  public isDismissed: boolean;
  constructor(public dataService: DataService) {}

  ngOnInit(): void {
    this.getFleetDetails();
  }

  public dismissBanner() {
    this.isDismissed = true;
  }
  public getFleetDetails() {
    this.dataService.getFleetDetails().subscribe({
      next: (res: PreferencesResponse) => {
        if (res?.pilotModeConfiguration) {
          this.showBanner = true;
        }
        if (res?.pilotModeConfiguration?.isEnabled) {
          this.showEnabledBanner = res?.pilotModeConfiguration?.isEnabled;
          this.getExpiryDateAndDays(res?.pilotModeConfiguration?.expiryDateUTC);
        }
        if (res?.pilotModeConfiguration?.isEnabled === false) {
          this.showDisabledBanner = true;
        }
        // for forever case no need to show banner notification
        if (res?.pilotModeConfiguration?.isEnabled === true && !('expiryDateUTC' in res.pilotModeConfiguration)) {
          this.showBanner = false;
        }
      },
      error: () => {},
    });
  }

  private getExpiryDateAndDays(date) {
    const expiryIsoDate = date;
    const expiryDate = new Date(expiryIsoDate);
    const today = new Date();

    const timeDiff = expiryDate.getTime() - today.getTime();
    this.daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    if (this.daysRemaining == 2) {
      this.showEnabledBanner = false;
      this.showExpireBanner = true;
    }
    const day = expiryDate.getDate().toString().padStart(2, '0');
    const month = (expiryDate.getMonth() + 1).toString().padStart(2, '0');
    const year = expiryDate.getFullYear();

    this.formattedDate = `${day}/${month}/${year}`;
  }
}
